import { Box } from '@mui/material'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useSwitchAccountLogin } from '@/components/organisms/common/Header/UserItemPopper/SwitchAccountLoginForm/hooks'
import { Button } from '@/components/uiParts/legacy/Button/BasicButton'
import { LabelingInput } from '@/components/uiParts/legacy/Input/LabelingInput'
import { TextField } from '@/components/uiParts/legacy/Input/TextField'
import { StackColumn } from '@/components/uiParts/legacy/Stack/Column'
import { PASSWORD_MIN_LENGTH } from '@/constants/constants'
import { stringFormat } from '@/utils/stringUtils'
import { validEmailFormat } from '@/utils/validation/common/validation'

/** アカウント切替用ログインフォーム。ダイアログに埋め込んで使用する */
export const SwitchAccountLoginForm = ({ close }: { close: () => void }) => {
  const { t } = useTranslation()
  const { formMethods, login } = useSwitchAccountLogin(close)
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = formMethods

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(login)}>
        <StackColumn spacing={3} width="25vw">
          <LabelingInput label={t('email_address')}>
            <TextField
              name="email"
              rules={{
                required: t('validation.required', {
                  text: t('email_address'),
                }),
                validate: (value: string) =>
                  validEmailFormat(value) ||
                  t('invalid_format', { text: t('email_address') }),
              }}
            />
          </LabelingInput>
          <LabelingInput label={t('password')}>
            <TextField
              type="password"
              name="password"
              rules={{
                required: t('validation.required', {
                  text: t('password'),
                }),
                minLength: {
                  value: PASSWORD_MIN_LENGTH,
                  message: stringFormat(
                    t('validation.password_requirements'),
                    String(PASSWORD_MIN_LENGTH),
                  ),
                },
              }}
            />
          </LabelingInput>
          <Box sx={{ pt: 1 }}>
            <Button
              type="submit"
              disabled={isSubmitting}
              sx={{ width: '100%' }}
            >
              {t('switch_account')}
            </Button>
          </Box>
        </StackColumn>
      </form>
    </FormProvider>
  )
}
